import React, { useContext } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { BlogCardContext } from './BlogCardContext';
import { ImageProps } from '../Image/types';

export type BlogCardImageProps = DefaultBsComponent & {
  className?: string;
  classNameImage?: string;
} & ImageProps;

export const BlogCardImage = ({
  classNameImage,
  className,
  as: Component = 'img',
  ...props
}: BlogCardImageProps) => {
  const context = useContext<any>(BlogCardContext);

  return (
    <div
      className={classNames(
        'BlogCardImage',
        'relative hidden overflow-hidden md:block',
        ['top', 'bottom'].includes(context?.imgPosition) &&
          'w-fullmd:z-0 aspect-4/3',
        context?.imgPosition === 'top' && 'md:top-0',
        context?.imgPosition === 'bottom' && 'md:bottom-0',
        ['right', 'left'].includes(context?.imgPosition) &&
          'hidden md:block rounded-12 md:w-1/2 ',

        className,
      )}
    >
      <Component
        className={classNames(
          'object-cover',
          'w-full h-full group-hover:scale-105 transition-all duration-300 ease-in-out',
          ['right', 'left'].includes(context?.imgPosition) && 'rounded-12',

          classNameImage,
        )}
        {...props}
      />

      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))',
        }}
      />
    </div>
  );
};
